<template>
  <component :is="layout"></component>
</template>

<script>
import { EventBus } from "@/event-bus";
import BlankLayout from "./layouts/BlankLayout.vue";
import MainLayout from "./layouts/MainLayout.vue";
import FullPageLayout from "./layouts/FullPageLayout.vue";
import ClassRoomLayout from "./layouts/ClassRoomLayoutWithHeader.vue";
import NewMainLayout from "./layouts/NewMainLayout.vue";
// import ClassRoomLayout from "./layouts/ClassRoomLayout.vue";
import { getOmisePublicKey } from "./services/omiseService";

export default {
  name: "App",

  components: {
    BlankLayout,
    MainLayout,
    ClassRoomLayout,
    FullPageLayout,
    NewMainLayout,
  },
  computed: {
    layout() {
      // console.log(this.$route.meta.layout)
      let layout = this.$route.meta.layout || "blank";
      if (layout === "blank") {
        return "blank-layout";
      } else if (layout === "classroom") {
        // return "classroom-layout"
        return "ClassRoomLayout";
      } else if (layout === "newmain") {
        // return "classroom-layout"
        return "NewMainLayout";
      }
      return `${layout}-layout`;
    },
    // isClassRoom() {
    //   let isClassRoom = this.$route.meta.isClassRoom || null
    //   if(isClassRoom) {
    //     return 'main container'
    //   }
    //   return ""
    // }
  },
  data: () => ({
    maxTry: 5,
    tryConfigOmiseCount: 0,
  }),
  beforeDestroy() {
    EventBus.$off("signout");
    EventBus.$off("changeLocale");
    EventBus.$off("configPayment");
  },
  created() {
    EventBus.$on("configPayment", () => {
      this.configOmise();
    });
  },
  mounted() {
    EventBus.$on("signout", () => {
      this.signout();
    });
    EventBus.$on("changeLocale", (locale) => {
      this.changeLocale(locale);
    });
    window.addEventListener("message", this.receiveMessage, false);
    this.$vuetify.lang.current = this.$store.getters.locale;
  },
  methods: {
    configOmise() {
      this.tryGetOmiseInstance().then((result) => {
        if (result) {
          getOmisePublicKey()
            .then((omisePublicKey) => {
              Omise.setPublicKey(omisePublicKey);
              OmiseCard.configure({
                publicKey: omisePublicKey,
              });
              this.$store.commit("setPayment", true);
              EventBus.$emit("configPaymentResult", true);
            })
            .catch((err) => {
              EventBus.$emit("configPaymentResult", false);
            });
        } else {
          if (this.tryConfigOmiseCount < this.maxTry) {
            setTimeout(() => {
              this.tryConfigOmiseCount++;
              this.configOmise();
            }, 2 * 1000);
          } else {
            alert("Can not initialize purchase feature");
          }
        }
      });
    },
    tryGetOmiseInstance() {
      return new Promise((resolve, reject) => {
        if (typeof Omise != "undefined") {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    changeLocale(locale) {
      this.$vuetify.lang.current = locale;
      localStorage.setItem("locale", locale);
    },
    signout() {
      this.$cookies.remove("user_token");
      this.$cookies.remove("user_info");
      this.$router.replace({ name: "login" });
    },
    receiveMessage(event) {
      if (event.data == "close") {
        EventBus.$emit("examClose");
      }
    },
  },
};
</script>
